import { NgModule } from '@angular/core';
import { PatientObjectiveApiService } from './patient-objective.service';

@NgModule({
  providers: [PatientObjectiveApiService],
})
export class PatientObjectiveApiModule {}

